import React from 'react';

const Screen = ({ x, children, label }) => (
  <g transform={`translate(${x},540)`}>
    <rect width="220" height="150" rx="8" fill="#05080c" stroke="#2a2d33" strokeWidth="3" />
    {children}
    <text x="10" y="142" fill="#C9A84C" fontSize="11" fontFamily="monospace" letterSpacing="2">{label}</text>
  </g>
);

/** Flight-deck frame drawn over the 3D view (cockpit camera). */
export function CockpitOverlay({ alt, spd, roll = 0 }) {
  return (
    <svg data-testid="flight-cockpit-overlay" className="pointer-events-none absolute inset-0 h-full w-full" viewBox="0 0 1600 800" preserveAspectRatio="xMidYMid slice">
      <defs>
        <mask id="ws">
          <rect width="1600" height="800" fill="white" />
          <path d="M140 470 L330 150 L770 120 L770 470 Z" fill="black" />
          <path d="M1460 470 L1270 150 L830 120 L830 470 Z" fill="black" />
        </mask>
        <clipPath id="pfdclip"><rect x="0" y="0" width="220" height="150" rx="8" /></clipPath>
        <linearGradient id="dash" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor="#15171b" /><stop offset="1" stopColor="#060708" /></linearGradient>
      </defs>
      <rect width="1600" height="800" fill="#0a0b0d" mask="url(#ws)" />
      <path d="M0 520 Q800 430 1600 520 L1600 800 L0 800 Z" fill="url(#dash)" />
      <path d="M0 520 Q800 430 1600 520" stroke="#C9A84C" strokeOpacity="0.35" strokeWidth="2" fill="none" />
      <Screen x={190} label="PFD">
        <g clipPath="url(#pfdclip)"><g transform={`rotate(${(-roll * 180) / Math.PI} 110 70)`}>
          <rect x="10" y="-40" width="200" height="110" fill="#1d4f8a" /><rect x="10" y="70" width="200" height="110" fill="#6b4320" />
        </g></g>
        <rect x="0" y="0" width="220" height="10" fill="#05080c" /><rect x="0" y="130" width="220" height="20" fill="#05080c" />
        <path d="M70 70 H100 M120 70 H150 M110 64 V76" stroke="#F3D36B" strokeWidth="3" />
        <text x="12" y="28" fill="#fff" fontSize="14" fontFamily="monospace">{`${spd} KT`}</text>
        <text x="140" y="28" fill="#fff" fontSize="14" fontFamily="monospace">{Math.round(alt / 100) * 100}</text>
      </Screen>
      <Screen x={450} label="NAV">
        <circle cx="110" cy="72" r="52" fill="none" stroke="#3b82f6" strokeOpacity="0.6" />
        <path d="M110 30 L118 72 L110 66 L102 72 Z" fill="#F3D36B" />
        <text x="96" y="22" fill="#4ADE80" fontSize="12" fontFamily="monospace">HDG</text>
      </Screen>
      <Screen x={930} label="ENG">
        {[40, 120].map((x) => <g key={x}><path d={`M${x} 100 A40 40 0 1 1 ${x + 70} 100`} fill="none" stroke="#333" strokeWidth="8" /><path d={`M${x} 100 A40 40 0 0 1 ${x + 62} 52`} fill="none" stroke="#4ADE80" strokeWidth="8" /></g>)}
        <text x="70" y="128" fill="#fff" fontSize="12" fontFamily="monospace">N1 94%</text>
      </Screen>
      <Screen x={1190} label="KOW-SAT">
        <text x="14" y="40" fill="#C9A84C" fontSize="13" fontFamily="monospace">TRANSPONDER</text>
        <text x="14" y="66" fill="#fff" fontSize="22" fontFamily="monospace">7000</text>
        <text x="14" y="96" fill="#F87171" fontSize="12" fontFamily="monospace">ADS-B DARK</text>
      </Screen>
      <rect x="760" y="110" width="80" height="380" fill="#0a0b0d" />
    </svg>
  );
}
